import { httpPost } from "../../../setup/axios/axiosUtils";
import { getUserTokenFromLocal } from "../../pages/Home/Components/Popups/CartPages/utils";
import { useState } from "react";
import { URL_CONSTANTS } from "../urlsLink";
import { useParams } from "react-router-dom";
const usePaymentGateways = () => {
  const { bussinessName } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    isError: false,
    errorMessage: "",
  });

  const [gateWaysData, setGateWaysData] = useState({});
  const [accessToken] = useState(getUserTokenFromLocal(bussinessName!));
  const getPaymentGateways = async () => {
    setLoading(true);
    var success = false;

    try {
      const res = await httpPost(
        `${URL_CONSTANTS.get("URL_GET_GATEWAYS")}`,
        {},
        {},
        accessToken
      );
      if (res.type === "success") {
        setLoading(false);
        success = true;
        setGateWaysData(res.gateways);
        return { success, res };
      } else {
        setError({
          isError: true,
          errorMessage: res.message,
        });
        setLoading(false);
        success = false;
        return success;
      }
    } catch (error: any) {
      setLoading(false);
      console.log(error.message);
      setError({
        isError: true,
        errorMessage: error.message,
      });
    }
  };

  return {
    getPaymentGateways,
    gatewayLoading: loading,
    error,
    gateWaysData,
  };
};

export default usePaymentGateways;
